<canvas-dialog
  (onClose)="dialogRef.close()"
  [title]="data.name"
  class="flex flex-col"
>
<div class="flex justify-center m-[20px]">
    <img [src]="data.url" />
</div>
</canvas-dialog>
